module.exports = __webpack_public_path__ + "media/icons/external-link-1be64e60.svg";